
 
 //FOR SIZE CHART MODAL

 function sizechartmodal() {
    var modal = document.getElementById('size-chart-modal');
    var btn = document.getElementById('open-size-chart');
    var span = document.getElementById('close-size-chart');

    if (btn && modal && span) {
      btn.onclick = function () {
        modal.style.display = 'block';
      }

      span.onclick = function () {
        modal.style.display = 'none';
      }

      window.onclick = function (event) {
        if (event.target == modal) {
          modal.style.display = 'none';
        }
      }
    }
}

// FOR FOOTER MOBILE COLLAPSIBLE CONTENT 

  function setupFooterCollapse() {
    const blocks = document.querySelectorAll(".footer__block--links");

    blocks.forEach(function (block, index) {
      const heading = block.querySelector("p.h6");
      const list = block.querySelector(".unstyled-list");

      if (heading && list) {
        // All blocks except the first: expanded by default
        if (index !== 0) {
          list.classList.add("active");
          heading.classList.add("is-open");
        }

        // All blocks (including first): allow toggle on click
        heading.addEventListener("click", function () {
          list.classList.toggle("active");
          heading.classList.toggle("is-open");
        });
      }
    });
  }

   //FOR COLLECTON DESCRIPTION TOGGLE FUNCTIONALITY 

  function collectiondesctoggle() {
    const desc = document.querySelector(".collection__description");
    const toggle = document.querySelector(".read-more-toggle");

    if (desc && toggle) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        desc.classList.toggle("expanded");
        toggle.textContent = desc.classList.contains("expanded")
          ? "Read Less"
          : "Read More";
      });
    }
  }

//FOR JUDGEME APP ZINDEX 

function judgemeindex() {
  const header = document.querySelector(".shopify-section--header");
  const wrapper = document.querySelector(".jdgm-revs-tab__wrapper");

  if (!header || !wrapper) return;

  function toggleHeaderClass() {
    if (wrapper.classList.contains("jdgm-show")) {
      header.classList.add("header-index");
    } else {
      header.classList.remove("header-index");
    }
  }

  // Initial check
  toggleHeaderClass();

  // Watch for class changes on wrapper
  const observer = new MutationObserver(toggleHeaderClass);
  observer.observe(wrapper, { attributes: true, attributeFilter: ["class"] });
}

// FOR LINK BOXES ARROWS 
    function linkboxarrow() {
        
          const wrappers = document.querySelectorAll(".collection-link-boxes");

          wrappers.forEach(wrapper => {
            const prevBtn = wrapper.querySelector(".button-prev");
            const nextBtn = wrapper.querySelector(".button-next");

            if (!prevBtn || !nextBtn) return;

            // Try both possible scroll containers inside this wrapper
            const possibleScrollContainers = wrapper.querySelectorAll(
              ".metafield-rich_text_field, .custom-link-boxes, .link-boxes_wrapper"
            );

            possibleScrollContainers.forEach(scrollContainer => {
              if (!scrollContainer) return;

              const pTags = scrollContainer.querySelectorAll("p");

              if (pTags.length <= 3) {
                prevBtn.style.display = "none";
                nextBtn.style.display = "none";
              } else {
                prevBtn.style.display = "block";
                nextBtn.style.display = "block";
              }

              // Set up scrolling behavior
              scrollContainer.style.overflowX = "auto";
              scrollContainer.style.whiteSpace = "nowrap";

              const scrollAmount = 200;

              prevBtn.addEventListener("click", () => {
                scrollContainer.scrollBy({ left: -scrollAmount, behavior: "smooth" });
              });

              nextBtn.addEventListener("click", () => {
                scrollContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
              });
            });
          });
      }



// FOR SOCIAL FEED ARROWS
function socialFeedArrowScroll() {

  // run only for mobile
  // if (window.innerWidth <= 767) {

    const sections = document.querySelectorAll(".mm-social-feed");

    sections.forEach(section => {
      const grid = section.querySelector(".mm-social-feed__grid");
      const prevBtn = section.querySelector(".button-prev");
      const nextBtn = section.querySelector(".button-next");

      if (!grid || !prevBtn || !nextBtn) return;

      grid.style.overflowX = "auto";
      grid.style.display = "flex";
      grid.style.scrollBehavior = "smooth";
      grid.style.webkitOverflowScrolling = "touch";

      const scrollAmount = grid.offsetWidth * 0.8;

      const toggleButtons = () => {
        if (grid.scrollWidth <= grid.clientWidth) {
          prevBtn.style.display = "none";
          nextBtn.style.display = "none";
        } else {
          prevBtn.style.display = "flex";
          nextBtn.style.display = "flex";
        }
      };

      toggleButtons();
      window.addEventListener("resize", toggleButtons);

      prevBtn.addEventListener("click", () => {
        grid.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      });

      nextBtn.addEventListener("click", () => {
        grid.scrollBy({ left: scrollAmount, behavior: "smooth" });
      });
    });

  //} // end if

}
//for judgeme review widget drag on product page
// function judgeMeDragScroll() {

 function judgeMeDragScroll() {

  const containers = document.querySelectorAll('.jdgm-rev-widg__reviews');

  containers.forEach(container => {
    if (container.dataset.dragInit === 'true') return;
    container.dataset.dragInit = 'true';

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    container.style.overflowX = 'auto';
    container.style.cursor = 'grab';

    container.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;

      isDown = true;
      container.classList.add('jdgm-is-dragging');

      startX = e.pageX;
      scrollLeft = container.scrollLeft;

      container.style.userSelect = 'none';
    });

    container.addEventListener('mouseleave', () => {
      isDown = false;
      container.classList.remove('jdgm-is-dragging');
      container.style.userSelect = '';
    });

    container.addEventListener('mouseup', () => {
      isDown = false;
      container.classList.remove('jdgm-is-dragging');
      container.style.userSelect = '';
    });

    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();

      const walk = (e.pageX - startX) * 1.2;
      container.scrollLeft = scrollLeft - walk;
    });
  });
}





// ---------------------- This will run all function in custom script file when interaction happens ---------------------- //

function RunAllfunction() {
  sizechartmodal();
  setupFooterCollapse();
  collectiondesctoggle();
  judgemeindex();
  linkboxarrow();
  judgeMeDragScroll();
  socialFeedArrowScroll();


}

// Run once after first user interaction
const runOnce = () => {
  RunAllfunction();
  events.forEach(evt => window.removeEventListener(evt, runOnce));
};

const events = ['scroll', 'mousemove', 'touchstart', 'keydown', 'click'];
events.forEach(evt => {
  window.addEventListener(evt, runOnce, { once: true, passive: true });
});




// Hide badge for Klavio
(function () {
  const STORAGE_KEY = 'hide_teaser';
  const TEASER_SELECTOR = '[class*="kl-teaser-"], .kl-teaser, [data-testid="animated-teaser"]';

  const hideIfNeeded = (teaser) => {
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      teaser.style.display = 'none';
    }
  };

  const addCloseBtn = (teaser) => {
    if (!teaser || teaser.querySelector('.mm-close-btn-ind')) return;

    teaser.style.position = teaser.style.position || 'relative';
    teaser.style.overflow = 'visible';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mm-close-btn-ind';
    btn.setAttribute('aria-label', 'Close');

 
    btn.innerHTML = `
      <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon-close" viewBox="0 0 16 16">
        <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"></path>
      </svg>
    `;

    btn.addEventListener('click', () => {
      teaser.style.display = 'none';
      sessionStorage.setItem(STORAGE_KEY, 'true');
    });

    teaser.appendChild(btn);
  };

  const handleTeaser = (teaser) => {
    hideIfNeeded(teaser);
    addCloseBtn(teaser);
  };

  const tryAttach = () => {
    document.querySelectorAll(TEASER_SELECTOR).forEach(handleTeaser);
  };

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches(TEASER_SELECTOR)) handleTeaser(node);
          if (node.querySelectorAll) node.querySelectorAll(TEASER_SELECTOR).forEach(handleTeaser);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  tryAttach();

  let attempts = 0;
  const t = setInterval(() => {
    if (attempts++ > 20) clearInterval(t);
    tryAttach();
  }, 500);
})();

// We turn off our social media badge
(function () {
  const STORAGE_KEY = 'hide_badge';
  const BADGE_SELECTOR = '#mmSocialBadge, .mm-social-badge';
  const CLOSE_SELECTOR = '#mmBadgeBtn-close';

  const hideIfNeeded = (badge) => {
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      badge.style.display = 'none';
    }
  };

  const addCloseListener = (badge) => {
    const closeBtn = badge.querySelector(CLOSE_SELECTOR);
    if (!closeBtn || closeBtn.dataset.mmCloseAttached === '1') return;

    closeBtn.dataset.mmCloseAttached = '1';
    closeBtn.style.cursor = 'pointer';

    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      badge.style.display = 'none';
      sessionStorage.setItem(STORAGE_KEY, 'true');
    });
  };

  const handleBadge = (badge) => {
    hideIfNeeded(badge);
    addCloseListener(badge);
  };

  const tryAttach = () => {
    document.querySelectorAll(BADGE_SELECTOR).forEach(handleBadge);
  };

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches(BADGE_SELECTOR)) handleBadge(node);
          if (node.querySelectorAll) node.querySelectorAll(BADGE_SELECTOR).forEach(handleBadge);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  tryAttach();
})();